import Avatar from "avatar-initials";

import RandomizeColors from "./randomizeColors";
import getInitialsName from "./getInitialsName";

const defaultName = "TrainingPort.NET";

const createAvatar = ({
  fullName = defaultName,
  size = 100,
  fontSize = 30
}) => {
  const fakeImg = document.createElement("img");

  new Avatar(fakeImg, {
    useGravatar: false,
    size,
    initials: getInitialsName(fullName),
    initial_fg: '#FFFFFF',
    initial_bg: RandomizeColors.randomizeColors(),
    initial_size: fontSize,
    initial_weight: 200,
    initial_font_family: "'Muli', 'Helvetica', 'Arial', 'sans-serif'"
  });

  return fakeImg.src;
};

export default createAvatar;
